import { createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const getFilters = createApiAction(
  types.FILTERS_GET,
  (payload) => api.getFilters(payload),
);
